import {
  IDrone,
  IDroneQueryFilters,
  IPaginatedQuery,
  IPaginatedResponce,
} from "@drone-parts.garphild.pro/interfaces";

import { QueryFunctionContext, QueryKey } from "react-query";
import RestApiQuery, { ApiEndpoints } from "../helpers/rest-api-query";

export async function fetchDrones(context: QueryFunctionContext): Promise<IPaginatedResponce<IDrone>> {
  const queryKey = context.queryKey as [QueryKey, IDroneQueryFilters & IPaginatedQuery];
  const [key, queryParams] = queryKey;
  const {
    statuses,
    dronesModels,
    templates,
    searchString,
    page,
    pageSize,
    showSent,
    inventarizationMode,
    ids,
    itemTypes,
  } = queryParams || {};

  const emptyResponse: IPaginatedResponce<IDrone> = {
    data: [],
    total: 0,
    page: 0,
    pageSize: 0,
    totalPages: 0,
    hasNext: false,
    hasPrev: false,
    toOrder:[],
    dronesModels: [],
  }

  try {
    if (!pageSize) {
      return emptyResponse;
    }
    const params: Record<string, any> = {
      inventarizationMode: inventarizationMode || false,
      showSent: showSent || false,
      searchString: searchString ?? '',
      'statuses': statuses?.map((status) => encodeURI(status)) || [],
      'dronesModels': dronesModels?.map((model) => encodeURI(model)) || [],
      'templates': templates?.map((template) => template === 'null' ? template : encodeURI(template)) || [],
      'itemTypes': itemTypes?.map((type) => encodeURI(type)) || [],
      ids: ids || [],
      page,
      pageSize,
    };

    const data = await RestApiQuery.get<IPaginatedResponce<IDrone>>(ApiEndpoints.Drones, params);

    if (!data) {
      throw new Error("Failed to load drones");
    }

    const planned: Record<string, Record<string, number>> = {};

    planned.all = {};

    data.data = data.data.map((drone) => {
      const total = drone.parts.reduce((acc, part) => {
        const cost = (part.item?.itemRealPrice || part.item?.itemPrice || 0) / (part.item?.unitsInPackage || 1);
        return acc + cost * part.quantity;
      }, 0);
      drone.total = total;
      return drone;
    });

    return data;
  } catch (error) {
    console.error("Load drones error", error);
    return emptyResponse;
  }
}

export async function fetchMaxDroneId(itemType = 'drone'): Promise<{maxId: number, itemType: string}> {
  const data = await RestApiQuery
    .get<{maxId: number, itemType: string}>(ApiEndpoints.DronesMaxId, { itemType })
    .then((response): {maxId: number, itemType: string} => {
      if (!response) {
        throw new Error("Failed to load max drone id");
      }
      return response;
    });
  return data;
}

export async function updateDrone(formData: Partial<IDrone>): Promise<boolean> {
  const data = await RestApiQuery.put(`/api/drones`, formData);
  return !!data;
}

export async function updateDroneCheckList(checkListState: { _id: string, title: string, value: boolean }): Promise<boolean> {
  const data = await RestApiQuery.patch(`/api/drones/checklist`, checkListState);
  return !!data;
}

export interface IUpdateDronePartParams {
  droneId: string;
  partKey: string;
  newItemId: string;
  quantity?: number;
}

export async function updateDronePart(params: IUpdateDronePartParams): Promise<{ success: boolean; drone?: IDrone }> {
  const data = await RestApiQuery.patch<{ success: boolean; drone?: IDrone }>(`/api/drones/part`, params);
  return data || { success: false };
}
